import React from 'react';
import {Query} from 'react-apollo';
import gql from 'graphql-tag';
import CardResearche from './cardResearche';
import { 
    Typography,
    withStyles,
} from '@material-ui/core';
import {Row, Col} from 'react-flexbox-grid';
import PropTypes from 'prop-types';

const styles = theme => ({
    contentTitle : {
        width : "100%",
        justifyContent : 'center',
        alignItems : 'center',
        display : 'flex',
        marginTop : 0
    },
    title : {
        fontFamily : "'Poppins', sans-serif"
    },
});

const ALL_RESEARCHERS = gql`
  query allResearchers {
    allResearchers {
      id
      name
      credentials
      descriptions
      photo
    }
  }
`;

/**
 * Componente para el listado de los investigadores
 * Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const ListAllResearchers = ({classes}) => {
    return(
        <Query query={ALL_RESEARCHERS}>
            {({loading, error, data}) => {
                return(
                    <div>
                        <div className={classes.contentTitle}>
                            <Typography 
                                variant="h4" 
                                align="center" 
                                className={classes.title}
                            >
                                Investigadores
                            </Typography>
                        </div>
                        <Row style={{textAlign : "center", marginTop : 24, padding : 24}}>
                            {data.allResearchers && data.allResearchers.map((item, key) => (
                                <Col xs={12} md={6} key={key}>
                                    <CardResearche item={item}/>
                                </Col>
                            ))}
                        </Row>
                    </div>
                )
            }}
        </Query>
    )
};

ListAllResearchers.propTypes = {
    classes : PropTypes.object
}

export default withStyles(styles) (ListAllResearchers);


// WEBPACK FOOTER //
// ./src/components/researchers/listAllResearchers.js